export const questions = [
  // Page 1: Sex/Gender (FIRST QUESTION)
  {
    page: 1,
    id: 'sex',
    apiId: 1400,
    type: 'radio',
    text: 'What was your sex assigned at birth?',
    required: true,
    namedField: 'sex',
    includeInQA: true,
    options: [
      { value: 'Male', label: 'Male' },
      { value: 'Female', label: 'Female' }
    ]
  },

  // Page 2: Conditional - Pregnancy Status
  {
    page: 2,
    id: 'pregnancyStatus',
    apiId: 1401,
    type: 'radio',
    text: 'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    required: true,
    conditional: true,
    dependsOn: {
      questionId: 'sex',
      value: 'Female'
    },
    includeInQA: true,
    options: [
      { value: 'Yes', label: 'Yes', disqualifying: true },
      { value: 'No', label: 'No' }
    ]
  },

  // Page 3: Height
  {
    page: 3,
    id: 'height',
    apiId: 1406,
    type: 'height',
    text: 'What is your height?',
    placeholder: 'e.g., 5 feet 10 inches',
    required: true,
    includeInQA: true
  },

  // Page 4: Weight
  {
    page: 4,
    id: 'weight',
    apiId: 1407,
    type: 'number',
    text: 'What is your weight in pounds?',
    placeholder: 'e.g., 180',
    required: true,
    includeInQA: true,
    validation: {
      min: 50,
      max: 500
    }
  },

  // Page 5: Current Symptoms (MOVED HERE - symptom assessment early)
  {
    page: 5,
    id: 'currentSymptoms',
    apiId: 1409,
    type: 'radio',
    text: 'Are you currently experiencing any of the following?',
    required: true,
    includeInQA: true,
    options: [
      { value: 'Fatigue or Low Energy', label: 'Fatigue or Low Energy' },
      { value: 'Memory Issues', label: 'Memory Issues' },
      { value: 'Difficulty Concentrating', label: 'Difficulty Concentrating' },
      { value: 'Depression or Anxiety', label: 'Depression or Anxiety' },
      { value: 'Sleep Disorders', label: 'Sleep Disorders' },
      { value: 'Chronic Pain', label: 'Chronic Pain' },
      { value: 'Other', label: 'Other' },
      { value: 'None of these apply to me', label: 'None of these apply to me' }
    ]
  },

  // Page 6: Primary Reason
  {
    page: 6,
    id: 'primaryReason',
    apiId: 1408,
    type: 'radio',
    text: 'What is your primary reason for requesting this medication?',
    required: true,
    includeInQA: true,
    options: [
      { value: 'General wellness', label: 'General wellness' },
      { value: 'Anti-Aging', label: 'Anti-Aging' },
      { value: 'Antioxidant benefits', label: 'Antioxidant benefits' },
      { value: 'Boost energy', label: 'Boost energy' },
      { value: 'Brighten skin', label: 'Brighten skin' },
      { value: 'Detoxification', label: 'Detoxification' },
      { value: 'Immune support', label: 'Immune support' },
      { value: 'Other', label: 'Other' }
    ]
  },

  // Page 7: Medical Conditions
  {
    page: 7,
    id: 'medicalConditions',
    apiId: 1403,
    type: 'textarea',
    text: 'Please identify all your current medical conditions',
    placeholder: 'List any current medical conditions or write "None"',
    required: true,
    namedField: 'medicalConditions',
    includeInQA: true,
    validation: {
      minLength: 2,
      maxLength: 1000
    }
  },

  // Page 8: Current Medications
  {
    page: 8,
    id: 'selfReportedMeds',
    apiId: 1404,
    type: 'textarea',
    text: 'Please list all your current medications including dosages',
    placeholder: 'List all medications and dosages or write "None"',
    required: true,
    namedField: 'selfReportedMeds',
    includeInQA: true,
    validation: {
      minLength: 2,
      maxLength: 1000
    }
  },

  // Page 9: Allergies
  {
    page: 9,
    id: 'allergies',
    apiId: 1405,
    type: 'textarea',
    text: 'Please list all of your known allergies',
    placeholder: 'List all allergies or write "None"',
    required: true,
    namedField: 'allergies',
    includeInQA: true,
    validation: {
      minLength: 2,
      maxLength: 500
    }
  },

  // Page 10: Symptoms Other Info (conditional)
  {
    page: 10,
    id: 'symptomsOtherInfo',
    apiId: 1410,
    type: 'textarea',
    text: 'Please provide further information about this condition',
    placeholder: 'Describe your symptoms...',
    required: true,
    conditional: true,
    dependsOn: {
      questionId: 'currentSymptoms',
      value: 'Other'
    },
    includeInQA: true
  },

  // Page 11: Previous Treatment
  {
    page: 11,
    id: 'previousTreatment',
    apiId: 1411,
    type: 'radio',
    text: 'Have you ever received anti-aging treatment before with metformin, glutathione or NAD?',
    required: true,
    includeInQA: true,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]
  },

  // Page 12: Previous Reactions (conditional)
  {
    page: 12,
    id: 'previousReactions',
    apiId: 1412,
    type: 'radio',
    text: 'Did you experience any allergies or negative reactions to any of these?',
    required: true,
    conditional: true,
    dependsOn: {
      questionId: 'previousTreatment',
      value: 'Yes'
    },
    includeInQA: true,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]
  },

  // Page 13: Previous Treatment Info (conditional)
  {
    page: 13,
    id: 'previousTreatmentInfo',
    apiId: 1413,
    type: 'textarea',
    text: 'Please tell us more about what you used and any reactions you experienced',
    placeholder: 'Describe your previous treatment and reactions...',
    required: true,
    conditional: true,
    dependsOn: {
      questionId: 'previousReactions',
      value: 'Yes'
    },
    includeInQA: true
  },

  // Page 14: Medical Exclusions
  {
    page: 14,
    id: 'medicalExclusions',
    apiId: 1414,
    type: 'radio',
    text: 'Do you have a known history of G6PD deficiency, CKD or liver cirrhosis?',
    required: true,
    includeInQA: true,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]
  },

  // Page 15: Cancer Treatment
  {
    page: 15,
    id: 'cancerTreatment',
    apiId: 1415,
    type: 'radio',
    text: 'Are you currently undergoing treatment for cancer, or have you been diagnosed with cancer in the past 6 months?',
    required: true,
    includeInQA: true,
    options: [
      { value: 'Yes', label: 'Yes', disqualifying: true },
      { value: 'No', label: 'No' }
    ]
  },

  // Page 16: Other Info
  {
    page: 16,
    id: 'otherInfo',
    apiId: 1416,
    type: 'textarea',
    text: 'What other information or questions do you have for the doctor?',
    placeholder: 'Any additional information for your medical provider...',
    required: false,
    includeInQA: true,
    validation: {
      maxLength: 1000
    }
  },

  // ====== CONTACT INFORMATION ======
  // Page 17: Names & DOB (multi-field)
  {
    page: 17,
    fields: [
      {
        id: 'firstName',
        type: 'text',
        label: 'First Name',
        placeholder: 'Enter your first name',
        required: true,
        validation: {
          minLength: 2,
          maxLength: 50,
          pattern: /^[a-zA-Z\s-]+$/
        }
      },
      {
        id: 'lastName',
        type: 'text',
        label: 'Last Name',
        placeholder: 'Enter your last name',
        required: true,
        validation: {
          minLength: 2,
          maxLength: 50,
          pattern: /^[a-zA-Z\s-]+$/
        }
      },
      {
        id: 'dateOfBirth',
        type: 'date',
        label: 'Date of Birth',
        placeholder: 'MM/DD/YYYY',
        required: true,
        validation: {
          minAge: 18,
          format: 'MM/DD/YYYY'
        }
      }
    ]
  },

  // Page 18: Email & Phone (multi-field)
  {
    page: 18,
    fields: [
      {
        id: 'email',
        type: 'email',
        label: 'Email Address',
        placeholder: 'your.email@example.com',
        required: true,
        validation: {
          pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        }
      },
      {
        id: 'phone',
        type: 'phone',
        label: 'Phone Number',
        placeholder: '(555) 123-4567',
        required: true,
        validation: {
          format: '(###) ###-####',
          length: 10
        }
      },
      {
        id: 'phoneConsent',
        type: 'checkbox',
        label: 'I understand my phone number is required for prescription processing, medical consultations, and important order updates. Our medical team or pharmacy may call or text regarding my treatment. RenuviaRX may also send promotional offers (text STOP to opt-out of marketing). Msg & data rates may apply. HIPAA protected.',
        required: true
      }
    ]
  },

  // ====== SHIPPING ADDRESS ======
  // Page 19: State
  {
    page: 19,
    id: 'shippingState',
    type: 'state',
    text: 'Where can we ship your medication?',
    placeholder: 'Select your state',
    required: true
  },

  // Page 20: Complete Address (multi-field)
  {
    page: 20,
    fields: [
      {
        id: 'shippingAddress1',
        type: 'address',
        label: 'Street Address',
        placeholder: 'Start typing your address...',
        required: true,
        googleMaps: true,
        validation: {
          minLength: 5,
          maxLength: 100
        }
      },
      {
        id: 'shippingAddress2',
        type: 'text',
        label: 'Apartment, Suite, Unit, etc. (optional)',
        placeholder: 'Apt #, Suite, Unit, etc.',
        required: false,
        validation: {
          maxLength: 50
        }
      },
      {
        id: 'shippingCity',
        type: 'text',
        label: 'City',
        placeholder: 'Enter your city',
        required: true,
        validation: {
          minLength: 2,
          maxLength: 50,
          pattern: /^[a-zA-Z\s-]+$/
        }
      },
      {
        id: 'shippingZip',
        type: 'text',
        label: 'ZIP Code',
        placeholder: '12345',
        required: true,
        validation: {
          pattern: /^\d{5}(-\d{4})?$/,
          minLength: 5,
          maxLength: 10
        }
      }
    ]
  }
];

// Consent questions (shown after main survey)
export const consentQuestions = [
  {
    id: 'pregnancyConsent',
    apiId: 1402,
    type: 'consent',
    title: 'Pregnancy Consent',
    content: `
      NAD+, Glutathione, and Metformin are not recommended during pregnancy or breastfeeding.
      If you become pregnant while using this medication, stop use immediately and contact your healthcare provider.

      By proceeding, you confirm that you are not pregnant, not breastfeeding, and will take appropriate precautions to prevent pregnancy while using this medication.
    `,
    conditional: true,
    dependsOn: {
      questionId: 'pregnancyStatus',
      value: 'No'
    },
    options: [
      {
        value: 'I have read and understand the above information, I understand the risks and wish to proceed',
        label: 'I consent and wish to proceed'
      },
      {
        value: 'I have read the information and do NOT wish to proceed',
        label: 'I do not consent',
        disqualifying: true
      }
    ]
  },

  {
    id: 'informedConsent',
    apiId: 1417,
    type: 'consent',
    title: 'Informed Consent Statement',
    content: `
      I understand that this is a telemedicine consultation and that my medical provider will review my information and determine if this treatment is appropriate for me.

      I understand that there are potential risks and benefits associated with this treatment, and I have been given the opportunity to ask questions.

      I consent to the prescribed treatment and understand that I should contact my provider if I experience any adverse effects.
    `,
    required: true,
    options: [
      {
        value: 'I have read the above information, I understand the risks and would like to proceed',
        label: 'I consent and wish to proceed'
      },
      {
        value: 'I have read the above information and I do not wish to continue',
        label: 'I do not consent',
        disqualifying: true
      }
    ]
  },

  {
    id: 'truthfulnessConsent',
    apiId: 1418,
    type: 'consent',
    title: 'Truthfulness Attestation',
    content: `
      I attest that all information I have provided in this intake form is true and accurate to the best of my knowledge.

      I understand that providing false or incomplete information may result in inappropriate medical treatment and potential harm to my health.

      I agree to update my medical provider if any of this information changes.
    `,
    required: true,
    options: [
      {
        value: 'I have read the above information and I do consent and wish to move forward',
        label: 'I consent and wish to proceed'
      },
      {
        value: 'I have read the above information and I do not wish to continue',
        label: 'I do not consent',
        disqualifying: true
      }
    ]
  }
];
